import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { toDate } from 'app/modules/main/helper/date-mapper';
import { AdvertiserTimeZoneSelectors } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.selectors';
import { PublisherTimeZoneSelectors } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.selectors';
import { IANAZone } from 'luxon';
import { tap } from 'rxjs';
import { merge } from 'rxjs';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'accountDate' })
export class AccountDatePipe implements PipeTransform {

  constructor(
    private readonly datePipe: DatePipe,
    private readonly advertiserTimeZoneSelectors: AdvertiserTimeZoneSelectors,
    private readonly publisherTimeZoneSelectors: PublisherTimeZoneSelectors,
  ) {
  }

  transform(
    date: Date | string | number | null | undefined,
    format?: string,
    timeZone?: string,
    locale?: string
  ): Observable<string> {

    if ((!(date instanceof Date) && !(typeof date === 'string')) || !!timeZone) {
      return of(this.datePipe.transform(date, format, timeZone, locale));
    }

    return merge(
      this.advertiserTimeZoneSelectors.getTimeZone(),
      this.publisherTimeZoneSelectors.getTimeZone(),
    )
      .pipe(
        first(),
        map(timeZone => IANAZone.create(timeZone)),
        map(zone => zone.formatOffset(toDate(date).getTime(), 'short')),
        map(offset => this.datePipe.transform(date, format, offset, locale))
      );
  }

}
